<template>
    <div class="about-style-5 rn-section-gapBottom">
        <div class="container">
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <div class="row row--0 about-wrapper align-items-center theme-shape">
                        <div class="col-lg-6">
                            <div class="thumbnail">
								<router-link class="image" to="/about-us">
									<img src="../../../assets/images/edge/Active/首页/服务介绍/homeBuilding.jpg" alt="About Images" href=""/>
								</router-link>                                
                            </div>
                        </div>
                        <div class="col-lg-6 mt_md--30 mt_sm--30">
                            <div class="content">
                                <div class="inner">
                                    <h4 class="title">大连爱智控制系统有限公司</h4>
                                    <p>原大连理工计算机控制工程有限公司</p>
                                    <ul class="contact-address">
                                        <li>
                                            成立于2004 年7 月，是以大连理工大学为依托的国家火炬计划重点高新技术企业。
                                        </li>
                                        <li>
                                            参与制定了国际标准 5 项，国家标准 6 项
                                        </li>
                                        <li>
                                            自主研发了MAC系列可编程控制系统、数控系统和机器人控制系统、PEC系列分布式控制系统，编程开发软件PLC_Config和监控管理组态开发软件DView等软硬件产品，并为用户提供自动化解决方案。
                                        </li>
                                    </ul>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../../icon/Icon'

    export default {
        name: 'AboutFive',
        components: {Icon}
    }
</script>